import { createContext, ReactNode, useState, useCallback } from 'react';

export interface HeaderActionsContextValue {
  headerActions: ReactNode;
  setHeaderActions: (node: ReactNode) => void;
  clearHeaderActions: () => void;
  /**
   * When true, the dashboard shell caps its content Container to the viewport
   * (instead of just a min-height), so a page can manage its own internal
   * scrolling (e.g. a fixed footer + scrollable middle panels). Opt-in per
   * route — every other page keeps the normal "whole page scrolls" behavior.
   */
  fullHeightContent: boolean;
  setFullHeightContent: (full: boolean) => void;
}

export const HeaderActionsContext = createContext<HeaderActionsContextValue>({
  headerActions: null,
  setHeaderActions: () => {},
  clearHeaderActions: () => {},
  fullHeightContent: false,
  setFullHeightContent: () => {}
});

export function HeaderActionsProvider({ children }: { children: ReactNode }) {
  const [headerActions, setHeaderActionsState] = useState<ReactNode>(null);
  const [fullHeightContent, setFullHeightContent] = useState(false);

  const setHeaderActions = useCallback((node: ReactNode) => {
    setHeaderActionsState(node);
  }, []);

  const clearHeaderActions = useCallback(() => {
    setHeaderActionsState(null);
  }, []);

  return (
    <HeaderActionsContext.Provider value={{ headerActions, setHeaderActions, clearHeaderActions, fullHeightContent, setFullHeightContent }}>
      {children}
    </HeaderActionsContext.Provider>
  );
}
